import React, { useContext, useState } from "react";
import { CircularProgress } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SaveIcon from "@mui/icons-material/Save";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import { UserContext } from "../../context/UserContext";
import ROLES from "../../util/roles";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const SaveButtons = ({ handleSubmit, handleApproved, scrollUp, showApprovalButton, isSaving }) => {
    const { user } = useContext(UserContext);
    const [expanded, setExpanded] = useState(false);
    const workflowElement = document.getElementById("workflows-table");
    const filesElement = document.getElementById("box-files-div");

    const hoverExpanded = () => {
        setExpanded(!expanded);
    };

    return (
        <div className="floatingSaveButtons">
            <div className="editPlanButtons">
                <a href=".." className="scrollUp">
                    <KeyboardArrowLeftIcon/> HOME &nbsp;
                </a>
                {!newPlan &&
                    <div
                        className="shortcutsContainer"
                        onMouseEnter={hoverExpanded}
                        onMouseLeave={hoverExpanded}
                    >
                        <div className="shortcutsHeader">
                            SHORTCUTS
                        </div>
                        {expanded && (
                            <div className="shortcutsButtons">
                                <a onClick={() => workflowElement.scrollIntoView({ behavior: "smooth" })}>
                                    WORKFLOWS
                                </a>
                                <a onClick={() => filesElement.scrollIntoView({ behavior: "smooth" })}>
                                    FILES
                                </a>
                            </div>
                        )}
                    </div>
                }
            </div>
            <div className="editPlanButtons">
                {scrollUp && (
                    <a
                        className="scrollUp"
                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    >
                        <KeyboardArrowUpIcon/>
                    </a>
                )}
                {showApprovalButton && checkRole(user, [ROLES.APPROVER]) && (
                    <a onClick={!isSaving ? handleApproved : undefined} className="saveButton">
                        {isSaving ? (
                            <CircularProgress
                                size={18}
                                style={{ color: "white", marginRight: "2px" }}
                            />
                        ) : (
                            <ThumbUpAltIcon fontSize="small"/>
                        )}
                        APPROVE
                    </a>
                )}
                {checkRole(user, [ROLES.ADMIN]) && (
                    <a onClick={(e) => !isSaving ? handleSubmit(e, true) : undefined} className="saveButton">
                        {isSaving ? (
                            <CircularProgress
                                size={18}
                                style={{ color: "white", marginRight: "2px" }}
                            />
                        ) : (
                            <SaveIcon fontSize="small"/>
                        )}
                        FORCE SAVE
                    </a>
                )}
                <a onClick={!isSaving ? handleSubmit : undefined}  className="saveButton">
                    {isSaving ? (
                        <CircularProgress
                            size={18}
                            style={{ color: "white", marginRight: "2px" }}
                        />
                    ) : (
                        <SaveIcon fontSize="small"/>
                    )}
                    SAVE
                </a>
            </div>
        </div>
    );
}

export default SaveButtons;